import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import { TIMING_FUNCTIONS } from './css-transitions.constants';

function BezierGraph({ size = 200, timingFunction = 'linear' }) {
  const { p1, p2 } = TIMING_FUNCTIONS[timingFunction];

  const MIN = 8;
  const MAX = 192;

  const x1 = normalize(p1[0] * 200, 0, 200, MIN, MAX);
  const y1 = normalize((1 - p1[1]) * 200, 0, 200, MIN, MAX);
  const x2 = normalize(p2[0] * 200, 0, 200, MIN, MAX);
  const y2 = normalize((1 - p2[1]) * 200, 0, 200, MIN, MAX);

  return (
    <Wrapper style={{ width: size }}>
      <Svg
        viewBox="0 0 200 200"
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Axis d={'M0,0 L0,200 L200,200'} />
        <Curve
          d={`M${MIN},${MAX} C${x1} ${y1}, ${x2} ${y2}, ${MAX},${MIN}`}
        />
      </Svg>
      <VerticalAxisLabel style={{ width: size }}>
        Progression
      </VerticalAxisLabel>
      <HorizontalAxisLabel style={{ width: size }}>
        Time
      </HorizontalAxisLabel>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  margin: 48px auto 64px;
`;

const Svg = styled.svg`
  display: block;
  overflow: visible;
`;

const Axis = styled.path`
  stroke: var(--color-gray-700);
  stroke-width: 3px;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const AxisLabel = styled.span`
  display: block;
  position: absolute;
  color: var(--color-gray-700);
  user-select: none;
  text-align: center;
`;

const VerticalAxisLabel = styled(AxisLabel)`
  bottom: 0px;
  left: -4px;
  transform-origin: bottom left;
  transform: rotate(-90deg);
`;

const HorizontalAxisLabel = styled(AxisLabel)`
  bottom: -28px;
`;

const Curve = styled.path`
  stroke: var(--color-secondary);
  stroke-width: 5px;
  stroke-linecap: round;
`;

export default BezierGraph;
